import { useState } from 'react';
import './App.css';
import Comment from './components/Comment/Comment';
import Form from './components/Form/Form';
import Replies from './components/Replies/Replies';
import comments from './data.json';
function CommentSection ({data,handleData}){
    return (
      data.comments.map(comment=>
      <div className="discussion" key={comment.id}>
        <Comment comment={comment} currentUser={data.currentUser} id={comment.id} handleData={handleData}/>  
        <Replies replies={comment.replies} currentUser={data.currentUser} id={comment.id} handleData={handleData}/>
      </div>
      
    )
    )
}

function App() {
 // console.log(comments)
if(!JSON.parse(localStorage.getItem('data')))
  localStorage.setItem('data',JSON.stringify(comments))

const [data,setData]= useState(JSON.parse(localStorage.getItem('data')))//aggiornamento dati
function handleData(){
  setData(()=>JSON.parse(localStorage.getItem('data')))
} 
return (

    <div id="App">
      <CommentSection data={data} handleData={handleData}/>
      <Form user= {data.currentUser} reply={false} handleData={handleData}/>
    </div>

  );
}

export default App;
